/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import Modal from './Modal.js';
import ModalHeader from './ModalHeader.js';
import ModalFooter from './ModalFooter.js';
import withModal from './withModal.js';

export default Modal;
export { ModalHeader, ModalFooter, withModal };
